// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ha-c","containerItemsCenter":"Skeleton_containerItemsCenter__2FQlV"};